import { fdSelectModelList } from '../../../models/fdSelect.model';
import { Options } from 'ng5-slider';
import { Component, EventEmitter, Input, Output, OnChanges, AfterContentChecked, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { fdSelectModel } from 'src/app/models/fdSelect.model';
import * as $ from 'jquery';


@Component({
    selector: 'fd-simple-multiselect',
    templateUrl: './fd-simple-multiselect.component.html',
    styleUrls: ['./fd-simple-multiselect.scss']
})
export class FdSimpleMultiSelectComponent implements OnChanges, AfterContentChecked {

    public showList: boolean;
    public noData: boolean;
    public filtroBusqueda: string;
    public elementList: fdSelectModelList[];
    public fdIndex: number;
    @Input() fdSelectOptions: fdSelectModel;
    @Input() listaElementos: fdSelectModelList[];
    @Output() buscarInformacion = new EventEmitter();
    @Output() listaSeleccionados = new EventEmitter();

    private options: fdSelectModel;
    constructor() {
        const maximo: number = 999999;
        const minimo: number = 1;        
        if (!this.fdIndex) {
            this.fdIndex = Math.floor(Math.random() * ((maximo + 1) - minimo) + minimo);
        }
        if (!this.fdSelectOptions) {
            this.fdSelectOptions = new fdSelectModel('Ingrese El valor', 'BUSCAR', null, null);
        }
        this.options = this.fdSelectOptions;
        this.elementList = this.listaElementos;
        this.showList = false;
        this.filtroBusqueda = '';
        this.noData = false;
    }
    ngOnChanges(changes: SimpleChanges) {
        this.elementList = this.listaElementos;
    }

    ngAfterContentChecked() {
        if (this.listaElementos.length > 0) {
            this.emitirSeleccionados();
        }
    }

    public guardarSeleccion() {
        this.showList = false;
        this.listaSeleccionados.emit({ elementosSeleccionados: this.listaElementos });
    }
    public showListP(event?) {
        if (this.showList == true) {
            $('#fdListaSelect' + this.fdIndex).css({ 'visibility': 'hidden' });
            this.showList = false;
        } else {
            $('#fdListaSelect' + this.fdIndex).css({ 'visibility': 'visible' });
            this.showList = true;
        }
    }

    public buscar() {
        this.buscarInformacion.emit({ filtro: this.filtroBusqueda });
    }

    // fromero
    // Método Check para emitir la lista de elementos seleccionados
    // 03/05/2019

    public checkElement(element: fdSelectModelList, estado?, index?) {
        element.checked = !element.checked;
        this.emitirSeleccionados();
    }
    
    public emitirSeleccionados() {
        this.filtroBusqueda = '';
        var c = 0;
        this.listaElementos.forEach(element => {
            if (element.checked) {
                c = c + 1;
                if (this.filtroBusqueda === '') {
                    this.filtroBusqueda = element.nombreElelemento;
                }
            }
        });
        if (c > 1) {
            this.filtroBusqueda += '(+' + c.toString() + ')';
        } else if (c == 0) {
            this.filtroBusqueda = "";
        }

        this.listaSeleccionados.emit({ elementosSeleccionados: this.listaElementos });
    }

    // métodos accesibilidad por teclado
    public moveDown() {

        const activeElement = document.activeElement;
        const nextSibling: any = document.activeElement.nextSibling;
        let id = nextSibling.id;

        if (activeElement.id === 'fd-search-input' + this.fdIndex) {
            id = document.activeElement.nextElementSibling.firstElementChild.firstElementChild.id;
            document.getElementById(id).focus();
        } else {
            if (id !== 'btnAccionSelect' + this.fdIndex) {
                document.getElementById(id).focus();
            } else {
                document.getElementById('btnfiltro' + this.fdIndex).focus();
            }
        }

    }
    public moveUp() {
        const previousSibling: any = document.activeElement.previousSibling;
        let id;
        if (previousSibling != null && previousSibling.id !== undefined) {
            id = previousSibling.id;
        } else {
            if (document.activeElement.id === 'btnfiltro' + this.fdIndex) {
                const longitudlista = document.activeElement.parentNode.parentNode.children.length;
                id = document.activeElement.parentNode.parentNode.children[longitudlista - 2].id;
            } else {
                id = 'fd-search-input' + this.fdIndex;
            }
        }
        document.getElementById(id).focus();
    }
}
